import { useSearchParams } from "react-router-dom";
import { QueryParams } from "../constants";

export const useGetSearchParam = (param: QueryParams) => {
  const [searchParams] = useSearchParams();

  return searchParams.get(param);
};
